import { render, staticRenderFns } from "./AbkNewsTreeNode.vue?vue&type=template&id=58c36b0e&scoped=true&"
import script from "./AbkNewsTreeNode.vue?vue&type=script&lang=js&"
export * from "./AbkNewsTreeNode.vue?vue&type=script&lang=js&"
import style0 from "./AbkNewsTreeNode.vue?vue&type=style&index=0&id=58c36b0e&scoped=true&lang=scss&"
import style1 from "./AbkNewsTreeNode.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c36b0e",
  null
  
)

export default component.exports